import { ViewProps } from './interactive.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentStartCover } from '../shared/component-parts';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import InteractiveExpandModal from './interactive-expand-modal';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';

const InteractiveView = (
  props: ViewProps & { onStimulusOpen?: () => void; disableModal?: boolean }
) => {
  const {
    type,
    properties,
    stimulusResourceProperties,
    onStimulusOpen,
    disableModal,
  } = props;

  const { isVisible, closeModal, openModal } = useSimpleModalState();

  const { style, setContainerElement, elementDimensions } =
    useContainerDimensions({
      aspectRatio: 16 / 9,
    });

  return stimulusResourceProperties?.link ? (
    <>
      <ComponentAspectRatio dimensions={properties.dimensionData}>
        <ComponentAbsoluteWrapper ref={setContainerElement}>
          <ComponentStartCover
            type={props.type}
            buttonLabel="Start"
            resourceName={props.stimulusResourceProperties?.resourceName || ''}
            backgroundImage={
              props.stimulusResourceProperties?.xlCoverImageUrls?.length
                ? getClosestImageUrl({
                    imageUrls:
                      props.stimulusResourceProperties.xlCoverImageUrls,
                    containerSize: elementDimensions?.width
                      ? Math.max(
                          elementDimensions.width,
                          elementDimensions.height
                        )
                      : window.innerWidth,
                    quality: ImageDisplayQuality.High,
                  })
                : stimulusResourceProperties?.coverImage?.original
            }
            style={style}
            onClick={
              !disableModal
                ? () => {
                    openModal?.();
                    onStimulusOpen?.();
                  }
                : undefined
            }
            data-selector="btn-start"
          />
        </ComponentAbsoluteWrapper>
      </ComponentAspectRatio>

      {isVisible && (
        <InteractiveExpandModal
          stimulusLink={stimulusResourceProperties.link}
          type={type}
          onClose={closeModal}
        />
      )}
    </>
  ) : null;
};

export default InteractiveView;
